import { getRoleName } from "../../shared/utils/roleMapping";

export const getToken = (state) => state.auth.tokens?.access_token;
export const getIsAuthenticated = (state) =>
  !!state?.auth?.user && !!state?.auth?.tokens?.access_token;
export const getUserFullName = (state) => {
  const firstName = state.auth.user?.first_name || "";
  const lastName = state.auth.user?.last_name || "";
  return `${firstName} ${lastName}`.trim();
};
export const getUserInitials = (state) => {
  const firstName = state.auth.user?.first_name || "";
  return `${firstName.charAt(0)}`.toUpperCase();
};
export const getAccountType = (state) => {
  const roleId = state.auth.mdm?.role_ids[0];
  return getRoleName(roleId);
};
export const getUserLoginId = (state) => state.auth.user?.admission_id || "";
export const getUserCrnId = (state) => state.auth.user?.crnId || "";
